/* @flow */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Activity from 'entities/Activity';
import * as actions from 'payments/reducers/activityRecipients';
import ActivityRecipient from 'entities/ActivityRecipient'; // eslint-disable-line
import ActivityRecipients from 'collections/ActivityRecipients'; // eslint-disable-line
import ActivityResponsesTableRow from 'payments/components/ActivityResponsesTableRow.jsx';
import Button from 'components/Button.jsx';
import cx from 'classnames';
import ModalTrigger from 'components/ModalTrigger.jsx';
import ActivityShareModal from './ActivityShareModal.jsx';
import React, { Component } from 'react';
import TabPanel from 'components/TabPanel.jsx';
import Tabs from 'components/Tabs.jsx';
import TitleHeader from 'components/TitleHeader.jsx';
import type {Attendance} from 'entities/ActivityRecipient'; // eslint-disable-line

const attendanceToTabLabel = {
  default: 'Invited',
  yes: 'Attending',
  maybe: 'Maybe',
  no: 'Declined',
  pending: 'Pending',
};

const selectedSortToTabNumber = {
  default: 0,
  yes: 1,
  maybe: 2,
  no: 3,
  pending: 4,
};

import './styles/ActivityResponsesTable.scss';
import './styles/ActivityTable.scss';

export type Sort = 'default' | Attendance;

type Props = {
  recipients: ActivityRecipients,
  patchActivityRecipient: (activityId: string, recipientId: string, data: Object) => *,
  activity: Activity,
  initialSort?: ?Sort,
  className?: ?string,
}

type State = {
  selectedSort: Sort,
}

export class ActivityResponsesTable extends Component {
  props: Props;

  state: State = {
    selectedSort: this.props.initialSort || 'default',
  }

  onTabChange = (index: number) => {
    const tabNumberToSelectedSort = ['default', 'yes', 'maybe', 'no', 'pending'];
    this.setState({ selectedSort: tabNumberToSelectedSort[index] });
  }

  handleNoteEdit = (recipient: ActivityRecipient, note: string) => {
    return this.props.patchActivityRecipient(this.props.activity.id, recipient.id, {
      note,
    });
  }

  renderRecipient(recipient: ActivityRecipient) {
    const displayPaidRow = this.props.activity.isOrHasCollectedMoneyOnline();

    return (
      <ActivityResponsesTableRow
        recipient={recipient}
        key={recipient.id}
        displayPaidRow={displayPaidRow}
        onNoteEdit={this.handleNoteEdit}
      />
    );
  }

  renderTableNux() {
    const title = `No ${attendanceToTabLabel[this.state.selectedSort]} Participants`;
    const subheader = 'Make sure everyone knows about your activity';
    const shareModal = <ActivityShareModal activity={this.props.activity} />;

    return (
      <div className="ActivityResponsesTable-nux">
        <table className="ActivityTable">
          <thead>
            <tr>
              <th>Guest</th>
              <th>Note</th>
              <th>Response</th>
              <th>Paid</th>
              <th />
            </tr>
          </thead>
          <tbody />
        </table>
        <TitleHeader
          className="ActivityResponsesTable-nux-text"
          title={title}
          subtext={subheader}>
          <ModalTrigger modal={shareModal}>
            <Button
              className="ActivityResponsesTable-nux-button"
              eventElementName="ActivityResponsesTable-nux-button">
              Invite People
            </Button>
          </ModalTrigger>
        </TitleHeader>
      </div>
    );
  }

  renderTable() {
    let recipients = this.props.recipients;

    if (this.state.selectedSort !== 'default') {
      recipients = this.props.recipients.filter(recipient => {
        return recipient.getAttendance() === this.state.selectedSort;
      });
    }

    if (recipients.length === 0) {
      return this.renderTableNux();
    }

    return (
      <table className="ActivityTable">
        <thead>
          <tr>
            <th>Name</th>
            <th>Note</th>
            <th>Response</th>
            <th>{this.props.activity.isOrHasCollectedMoneyOnline() && 'Paid'}</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {recipients.map((recipient) => this.renderRecipient(recipient))}
        </tbody>
      </table>
    );
  }

  render() {
    const summary = this.props.activity.getRecipientSummary();
    return (
      <div className={cx('ActivityResponsesTable', this.props.className)}>
        <div className="ActivityResponsesTable-tabs">
          <Tabs
            tabActive={selectedSortToTabNumber[this.state.selectedSort]}
            orientation="vertical"
            size="xsmall"
            type="bar"
            onTabChange={this.onTabChange}>
            <TabPanel title={<span>Invited ({summary.getInvitedCount()})</span>} />
            <TabPanel title={<span>Yes ({summary.getAttendingCount()})</span>} />
            <TabPanel title={<span>Maybe ({summary.getMaybeCount()}) </span>} />
            <TabPanel title={<span>No ({summary.getNotAttendingCount()})</span>} />
            <TabPanel title={<span>Not Responded ({summary.getNotRespondingCount()})</span>} />
          </Tabs>
        </div>
        <div className="ActivityResponsesTable-tabsPanels">
          {this.renderTable()}
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    patchActivityRecipient: actions.patchActivityRecipient,
  }, dispatch);
}

// $FlowIssue
export default connect(
  undefined,
  mapDispatchToProps,
)(ActivityResponsesTable);



// WEBPACK FOOTER //
// ./src/payments/components/ActivityResponsesTable.jsx